import { render } from "./ConceptList.vue?vue&type=template&id=9423a0d6&scoped=true"
import script from "./ConceptList.vue?vue&type=script&lang=js"
export * from "./ConceptList.vue?vue&type=script&lang=js"

import "./ConceptList.vue?vue&type=style&index=0&id=9423a0d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9423a0d6"]])

export default __exports__